var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M16.9,16.239l-1.54-1.54,1.54-1.54a.467.467,0,0,0-.66-.66L14.7,14.04l-1.54-1.54a.467.467,0,1,0-.66.66l1.54,1.54-1.54,1.54a.451.451,0,0,0,0,.66.464.464,0,0,0,.66,0l1.54-1.54,1.54,1.54a.469.469,0,0,0,.66,0A.464.464,0,0,0,16.9,16.239Z",
    transform: "translate(-5.328 -5.325)",
    fill: "#102250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M9.375,4.183A5.19,5.19,0,1,1,5.7,5.7a5.158,5.158,0,0,1,3.672-1.52m0-.808a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z",
    transform: "translate(0 0)",
    fill: "#102250"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosClose);
export default __webpack_public_path__ + "static/media/ios-close.c1b3ddbd9e46dec41f8d027965f03624.svg";
export { ForwardRef as ReactComponent };